module.exports = __webpack_public_path__ + "static/images/logo-google.4e11ef005da539ff35b6e9f4124a3835.png";